<div class="lang-select-wrap">
  <p-select
    [options]="languages()"
    optionLabel="label"
    [ngModel]="selectedLanguage()"
    (ngModelChange)="onLanguageChange($event)"
    [appendTo]="appendTo()"
    styleClass="lang-select"
    [pt]="{
      root: {
        class:
          '!w-full !h-10 !rounded-[10px] !border-0 !bg-transparent !shadow-none hover:!bg-transparent focus:!bg-transparent',
      },
      label: {
        class: '!flex !items-center !justify-center !p-0 !overflow-visible !gap-1',
      },
      dropdown: { class: '!w-6 !text-[color:var(--theme-text-secondary)]' },
    }"
  >
    <ng-template pTemplate="value" let-lang>
      @if (lang) {
        <img
          class="lang-flag lang-flag--selected"
          [ngSrc]="lang.flagSrc"
          width="24"
          height="20"
          [alt]="lang.label"
        />
      }
    </ng-template>

    <ng-template pTemplate="selectedItem" let-lang>
      @if (lang) {
        <img
          class="lang-flag lang-flag--selected"
          [ngSrc]="lang.flagSrc"
          width="24"
          height="20"
          [alt]="lang.label"
        />
      }
    </ng-template>

    <ng-template pTemplate="item" let-lang>
      <span class="lang-item">
        <img
          class="lang-flag"
          [ngSrc]="lang.flagSrc"
          width="20"
          height="20"
          [alt]="lang.label"
        />
        <span class="lang-label">{{ lang.label }}</span>
      </span>
    </ng-template>
  </p-select>
</div>